module.exports = __webpack_public_path__ + "static/lachat_mario_1-edd5f1eb3237fc6f7d9650920f154c9a.jpg";